import React from 'react';

import {
  Box,
  useColorModeValue,
  useDisclosure,
  Grid,
  GridItem,
} from '@chakra-ui/react';
import Header from '../../Components/Header';
import PageHeader from '../../Components/Header/PageHeader';
import Inbox from '../../Components/conversations/Inbox.js';
import ThreadsArea from '../../Components/conversations/ThreadsArea.js';
import ContactInfo from '../../Components/conversations/ContactInfo.js';

import { useSelector, useDispatch } from 'react-redux';

const Conversations = () => {
  const bgColor = useColorModeValue('white.primary', 'blue.primary');

  const dispatch = useDispatch();

  const isMobile = useSelector((s) => s?.responsive?.isMobile);
  const mobileView = useSelector((s) => s?.responsive?.mobileView);

  if (!isMobile)
    return (
      <Box
        w={{ xl: '85%', lg: '85%', md: '100%', sm: '100%' }}
        height="100%"
        bg={bgColor}
        px="5"
        position="relative"
      >
        <Header />
        <PageHeader title="Conversations" />

        <Grid templateColumns="repeat(4, 1fr)" height="83vh">
          <GridItem colSpan={1}>
            <Box height="">
              <Inbox />
            </Box>
          </GridItem>
          <GridItem
            colSpan={2}
            borderLeft="solid 1px grey"
            borderRight="solid 1px grey"
            position="relative"
          >
            <Box height="">
              <ThreadsArea />
            </Box>
          </GridItem>
          <GridItem colSpan={1}>
            <Box height="100%">
              <ContactInfo />
            </Box>
          </GridItem>
        </Grid>
      </Box>
    );

  // ─────────────────────────────────────
  // MOBILE — single panel, switches by mobileView
  // ─────────────────────────────────────

  return (
    <Box
      w={{ xl: '100%', lg: '100%', md: '100%', sm: '100%' }}
      height="100%"
      bg={bgColor}
      px="5"
      position="relative"
    >
      {mobileView === 'rooms' && <Inbox />}
      {mobileView === 'thread' && <ThreadsArea />}
      {mobileView === 'info' && <ContactInfo />}
    </Box>
  );
};

export default Conversations;
